import _filter from 'lodash/filter';
import _includes from 'lodash/includes';
import _cloneDeep from 'lodash/cloneDeep';

import assignIds from 'utils/assignIdAndParent';
import initialState from './initialState';
import actionType from './actionType';
import refRoutes from '../../constants/refDataRoutes'


const refDataRoutes = ['Stimulation Data', 'Stimulation System'];

const appConfigurationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.CHANGE_LAYOUT:
            return {
                ...state,
                layoutType: action.payload,
            };
        case actionType.CHANGE_LAYOUT_WIDTH:
            return {
                ...state,
                layoutWidth: action.payload,
            };
        case actionType.CHANGE_SIDEBAR_THEME:
            return {
                ...state,
                leftSideBarTheme: action.payload,
            };
        case actionType.CHANGE_SIDEBAR_TYPE:
            return {
                ...state,
                leftSideBarType: action.payload,
            };
        case actionType.TOGGLE_RIGHT_SIDEBAR:
            return {
                ...state,
                showRightSidebar: !state.showRightSidebar,
            };
        case actionType.SHOW_RIGHT_SIDEBAR:
            return {
                ...state,
                showRightSidebar: true,
            };
        case actionType.HIDE_RIGHT_SIDEBAR:
            return {
                ...state,
                showRightSidebar: false,
            };
        case actionType.INIT_MENU:
            return { ...state, ...action.payload };
        case actionType.INIT_MENU_SUCCESS:
            return { ...state, ...action.payload };
        case actionType.CHANGE_ACTIVE_MENU_FROM_LOCATION:
            return { ...state };
        case actionType.CHANGE_ACTIVE_MENU_FROM_LOCATION_SUCCESS:
            return {
                ...state,
                activatedMenuItemIds: [action.payload],
            };
        case actionType.GET_APPLICATION_DASHBOARD:
            return {
                ...state,
                appDashboard: action.payload,
            };
        case actionType.GET_APPLICATION_ROUTES_SUCCESS: {
            if (action.payload.length > 0) {
                let appRoutes = [];
                if (localStorage.getItem('isRefData') === 'true') {
                    appRoutes = _cloneDeep(refRoutes);
                    const [dashboard] = _filter(action.payload, (item) => item.name === 'Dashboard');
                    // dashboard.header = 'Reference Data';
                    return {
                        ...state,
                        appRoutes:action.payload,
                        menuItems: assignIds([dashboard, ...appRoutes]),
                    };
                }
                appRoutes = _filter(action.payload, (item) => !_includes(refDataRoutes, item.name));
                return {
                    ...state,
                    appRoutes: action.payload,
                    menuItems: assignIds(appRoutes),
                };
            }
            return state

        }
        case actionType.SET_BLOCK_REF_DATA_ROUTES: {
            if (state.appRoutes.length > 0) {
                const appRoutes = refRoutes
                const [dashboard] = _filter(state.appRoutes, (item) => item.name === 'Dashboard');
                // dashboard.header = 'Reference Data';
                return {
                    ...state,
                    menuItems: assignIds([dashboard, ...appRoutes]),
                };
            }
            break;
        }
        case actionType.SET_BLOCK_RECON_ROUTES: {
            console.log("SET_BLOCK_RECON_ROUTES")
            const [dashboard] = _filter(state.appRoutes, (item) => item.name === 'Dashboard');
            // dashboard.header = 'Block Recon';
            const appRoutes = _filter(state.appRoutes, (item) => (!_includes(refDataRoutes, item.name) && item.name !== 'Dashboard'));
            return {
                ...state,
                menuItems: assignIds([dashboard, ...appRoutes]),
            };
        }
        default:
            return state;
    }
};

export default appConfigurationReducer;
